<template>
  <q-dialog
    v-model="isShowing"
    persistent
  >
    <q-card>
      <q-card-section>
        <img
          v-if="logo"
          :src="logo"
        >

        <div class="text-body1 text-center q-pa q-mb-lg">
          {{ $t('payment.secure3d.hint') }}
        </div>

        <q-form
          v-if="fields"
          :action="url"
          method="post"
          target="_blank"
          rel="noreferrer"
        >
          <div
            v-for="([name, value], index) in Object.entries(fields)"
            :key="index"
            class="hidden"
          >
            <q-input
              v-if="value"
              type="hidden"
              :name="name"
              :value="value"
            />
          </div>

          <div class="text-center q-mb-md">
            <q-btn
              v-close-popup
              class="on-left"
              :label="$t('payment.secure3d.cancel')"
              @click="hide"
            />

            <q-btn
              v-close-popup
              type="submit"
              color="secondary"
              :label="$t('payment.secure3d.submit')"
            />
          </div>

          <div class="text-body1 text-center q-pa hidden">
            <q-btn
              flat
              size="md"
              color="primary"
              @click="openAbout"
            >
              {{ $t('payment.secure3d.about') }}
            </q-btn>
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { openURL } from 'quasar';

export default {
  name: 'PaymentTdsForm',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    fields: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      isShowing: false,
    };
  },

  computed: {
    logo() {
      if (this.fields?.IssuerLogo) {
        return this.fields.IssuerLogo;
      }

      return false;
    },
  },

  watch: {
    show(value) {
      this.isShowing = value;
    },
  },

  methods: {
    hide() {
      this.isShowing = false;
      this.$emit('close');
    },

    openAbout() {
      openURL('https://www.valitor.is/um-valitor/oryggismal/oryggismal-veflausnir/3d-secure/');
    },
  },
};
</script>
